import type * as Types from '../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateCompanyMutationVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
}>;


export type CreateCompanyMutationPage = { readonly __typename?: 'RootMutationType', readonly createCompany: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly uuid: string, readonly name: string, readonly tokens: ReadonlyArray<{ readonly __typename?: 'OauthProviderToken', readonly id: string, readonly lastError?: string | null, readonly provider: Types.OauthProvider }> } };


export const CreateCompanyDocument = gql`
    mutation CreateCompany($name: String!) {
  createCompany(name: $name) {
    id
    uuid
    name
    tokens {
      id
      lastError
      provider
    }
  }
}
    `;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutationPage, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutationPage, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutationPage, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutationPage>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutationPage, CreateCompanyMutationVariables>;